// extracted by mini-css-extract-plugin
export var decrement = "numeric-input-module--decrement--Wep4c";
export var increment = "numeric-input-module--increment--KIhFN";
export var input = "numeric-input-module--input--aI96j";
export var wrap = "numeric-input-module--wrap---fT8G";